import React, { useState } from "react";
import "./AddressConstraint.css";

function SiteVisit(props) {
  const isLoaded = true;
  const [arrivalTime, setArrivalTime] = useState(props.arrivalTime ? props.arrivalTime : "");
  const [departureTime] = useState(props.departureTime ? props.departureTime : "");
  const [endLocationAddress, setEndlocationAddress] = useState(props.endLocationAddress ? props.endLocationAddress : "");

  const [startLocationAddress, setStartLocationAddress] = useState(props.startLocationAddress ? props.startLocationAddress : "");

  const [timeOnProperty, setTimeOnProperty] = useState(props.timeOnProperty ? props.timeOnProperty : 0);

  const [commuteTimeToNextSite] = useState(props.commuteTimeToNextSite ? props.commuteTimeToNextSite : 0);

  return !isLoaded ? (
    <></>
  ) : (
    <>
      <div>
        Start Address:
        <input type="text" value={startLocationAddress} onChange={(e) => setStartLocationAddress(e.target.value)} style={{ width: "300px" }} readOnly={true} />
        Commute time:
        <input type="number" value={commuteTimeToNextSite} readOnly={true} />
        Arrival time:
        <input
          type="time"
          id="commuteTime"
          name="commuteTime"
          min="09:00"
          max="18:00"
          value={arrivalTime}
          onChange={(e) => {
            setArrivalTime(e.target.value);
          }}
          readOnly={true}
        />
        Site visit time:
        <input
          type="number"
          value={timeOnProperty}
          onChange={(e) => {
            setTimeOnProperty(e.target.value);
          }}
        />
        End Address:
        <input type="text" value={endLocationAddress} onChange={(e) => setEndlocationAddress(e.target.value)} style={{ width: "300px" }} readOnly={true} />
        Departure time:
        <input
          type="time"
          id="commuteTime"
          name="commuteTime"
          min="09:00"
          max="18:00"
          value={departureTime}
          onChange={(e) => {
            setArrivalTime(e.target.value);
          }}
          readOnly={true}
        />
      </div>
    </>
  );
}

export default SiteVisit;
